export const spaceStateTranslations = {
  AVAILABLE: 'spaces:common.state.available',
  BLOCKED: 'spaces:common.state.unavailable',
  BOOKED: 'spaces:common.state.booked',
} as const;
